"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var setClauseValue_1 = require("../setClauseValue");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Removes the phrase pill from the input box of the 'includes' type of clauses
 * @param clauseId the id of the clause to remove the phrase from
 * @param phraseToRemove the phrase to remove from the clause
 */
exports.default = legacy_1.action('removePhraseFromClause')(function removePhraseFromClause(clauseId, phraseToRemove) {
    var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseValue;
    var indexToRemove = existingPhrases.indexOf(phraseToRemove);
    if (indexToRemove == -1) {
        throw new Error('Phrase not found in existing phrases');
    }
    existingPhrases.splice(indexToRemove, 1);
    setClauseValue_1.default(existingPhrases, clauseId);
});
//# sourceMappingURL=removePhraseFromClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/removePhraseFromClause.js
// module id = 3746
// module chunks = 2